// import React, { useState, useEffect } from 'react';
// import '@stripe/stripe-js';
// import { Button } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import ManageBankAccts from './ManageBankAccts';
// import BankForm from './bankForm';
// import API from '../../../utils/API';
// import Transactions from './Transactions';
// import './managePay.css';
// import { Link } from 'react-router-dom';
// import { Modal } from 'react-bootstrap';
// import { saveOrg } from '../../../redux/actions';

// const ManagePay: React.FC = (props: any) => {
//   const reduxOrg = useSelector((state: any) => state.org);
//   const [showConnect, setShowConnect] = useState(false);
//   const [onboardComplete, setOnboardComplete] = useState(false);
//   const [onboardPaypalComplete, setOnboardPaypalComplete] = useState(false);
//   const [accountDisconnection, setAccountDisconnection] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [manageBankAccts, setManageBankAccts] = useState(false);
//   const [fullScreenLoader, setFullScreenLoader] = useState(false);
//   const [addingAcct, setAddingAcct] = useState(false);
//   const [accountList, setAccountList] = useState([]);
//   const [connectstripe, setConnectstripe] = useState(false);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (reduxOrg._id) {
//       setLoading(true);
//       try {
//         API.getStripeAcct(reduxOrg.actionItems?.stripeID)
//           .then((res: any) => {
//             if (res.data?.details_submitted) {
//               setOnboardComplete(true);
//               API.findNP(reduxOrg._id)
//                 .then((nonprofit: any) => {
//                   if (!nonprofit.stripeComplete) {
//                     API.updateNP({ ...nonprofit.data, stripeComplete: true })
//                       .catch((err: any) => {
//                         console.log(err)
//                       });
//                   }
//                 }).catch((err: any) => {
//                   console.log(err)
//                 });;
//             }
//             setLoading(false);
//           })
//         if (reduxOrg?.paypal?.merchantId) {
//           setOnboardPaypalComplete(true);
//         }
//       } catch (error) {
//         console.log(error);

//       } finally {
//         console.log('finnaly calling');
//         setLoading(false)
//       }

//     }
//   }, []);

//   const updateUserInformation = async (event: any) => {
//     event.preventDefault();
//     setLoading(true);
//     try {
//       const response: any = await API.updateUserStripeInfo({ stripeID: reduxOrg.actionItems?.stripeID });
//       if (response) {
//         setLoading(false);
//         if (response.data?.error?.raw?.message) {
//           window.alert(response.data.error.raw.message);
//         } else {
//           window.location.replace(response.data.links);
//         }
//       }
//     } catch (error) {
//       console.log(error)
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getBankAccts();
//   }, []);

//   const getBankAccts = async () => {
//     setLoading(true);
//     try {
//       const response: any = await API.getBankAcct(
//         reduxOrg.actionItems?.stripeID
//       );

//       if (response.status === 200) {
//         setLoading(false);
//         setAccountList(response.data)
//       }
//     } catch (error) {
//       console.log(error)

//     } finally {
//       setLoading(false);

//     }
//   };

//   const createPartnerReferral = async (url: string , OrgId : string) => {
//     setFullScreenLoader(true)
//     try {
//       const response = await API.createPartnerReferral(url , OrgId);
//       const paypalLink = response.data.links.find((link: any) => link.rel === 'action_url');
//       localStorage.setItem('prev-url', window.location.pathname);
//       window.location.href = paypalLink.href;
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const removePaypal = async () => {
//     setFullScreenLoader(true)
//     setAccountDisconnection(false)
//     try {
//       const res: any = await API.updateDashboard({
//         npID: reduxOrg._id,
//         removePaypal: true
//       })
//       setOnboardPaypalComplete(false)
//       setFullScreenLoader(false)
//       if (res?.data?.nonprofit?.name) { dispatch(saveOrg(res?.data?.nonprofit)) }
//     } catch (error) {
//       setFullScreenLoader(false)
//       window.alert('We encountered an error. Please contact us if it happens again, thanks!')
//     }

//   };

//   const renderOnboardingComplete = () => {
//     return (
//       <>
//         {connectstripe ?
//           <BankForm addingAcct={addingAcct} setAddingAcct={setAddingAcct} accountList={accountList} setAccountList={setAccountList} setConnectstripe={setConnectstripe} />
//           :
//           <>
//             {onboardComplete ?
//               <div className="manage-account-button">
//                 <Button className='managepay-success' onClick={() => setManageBankAccts(!manageBankAccts)}>
//                   {manageBankAccts ? 'Done Managing Bank Accounts' : 'Manage Bank Accounts'}
//                 </Button>
//                 {(accountList.length > 0) && <Button className='managepay-success' onClick={updateUserInformation}>Update User Information</Button>}
//               </div>
//               : null
//             }
//             <div className="coonect-payment-account">
//               <button onClick={() => { setShowConnect(true) }}>Connect</button>
//             </div>
//             {manageBankAccts &&
//               <div className="card-infor">
//                 <h4>Bank Account Information</h4>
//                 <p>Indicate details of what bank account you want the donations to be deposited.</p>
//               </div>
//             }
//             {manageBankAccts && <ManageBankAccts addingAcct={addingAcct} setAddingAcct={setAddingAcct} accountList={accountList} setAccountList={setAccountList} setConnectstripe={setConnectstripe} />}
//             <Transactions />
//           </>
//         }

//       </>
//     );
//   };

//   const renderManagePay = () => {
//     if (loading) {
//       return <h3 style={{ height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>LOADING....</h3>;
//     } else if (onboardComplete || onboardPaypalComplete) {
//       return renderOnboardingComplete();
//     } else {
//       return (
//         <>
//           {fullScreenLoader &&
//             <div className="full-screen-loading">
//               <span className="loader"></span>
//             </div>
//           }
//           <div className="connect-stripe-paypal">
//             {!connectstripe ?
//               <div className="connect-buttons">
//                 <button onClick={() => { setConnectstripe(true) }}>Connect Stripe</button>
//                 <button onClick={() => createPartnerReferral(`${window.location.origin}/paypal-onboarding-complete` , reduxOrg._id)}>Connect Paypal</button>
//               </div> :
//               <BankForm addingAcct={addingAcct} setAddingAcct={setAddingAcct} accountList={accountList} setAccountList={setAccountList} setConnectstripe={setConnectstripe} />
//             }
//           </div>
//         </>
//       )
//     }
//   };

//   return (
//     <>
//       {fullScreenLoader &&
//         <div className="full-screen-loading">
//           <span className="loader"></span>
//         </div>
//       }
//       <div className='manage-pay-wrapper aaa'>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <h1 className='manage-pay-h2'>Donations</h1>
//           <div className="go-back">
//             <Link to={'/dashboard'}>
//               Go Back to Dashboard
//             </Link>
//           </div>

//         </div>
//         {renderManagePay()}
//       </div>
//       <Modal centered show={showConnect} onHide={() => setShowConnect(false)} className='requires-action-popups'>
//         <h1>Connect Account</h1>
//         <div className="buttonns">
//           {onboardComplete ? null : <button onClick={() => { setConnectstripe(true); setShowConnect(false) }}>Connect Stripe</button>}
//           {onboardPaypalComplete ?
//             <button onClick={() => { setAccountDisconnection(true); setShowConnect(false) }}>Disconnect PayPal</button> :
//             <button onClick={() => createPartnerReferral(`${window.location.origin}/paypal-onboarding-complete` , reduxOrg._id)}>Connect PayPal</button>
//           }
//         </div>
//       </Modal>
//       <Modal centered show={accountDisconnection} onHide={() => setAccountDisconnection(false)} className='requires-action-popups'>
//         <h1>Account Disconnection</h1>
//         <p>Disconnecting your PayPal account will prevent you from offering PayPal services and products on your website. Do you wish to continue?</p>
//         <div className="buttonns">
//           <button onClick={removePaypal}>Confirm</button>
//           <button onClick={() => setAccountDisconnection(false)}>Cancel</button>
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default ManagePay;

import React, { useState, useEffect } from 'react';
import '@stripe/stripe-js';
import { useSelector } from 'react-redux';
import API from '../../../utils/API';
import DonationsTable from '../../../components/DashboardLayout/DonationsTable/DonationsTable';
import './managePay.css';
import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';

const ManagePay: React.FC = (props: any) => {
  const reduxOrg = useSelector((state: any) => state.org);
  const [onboardComplete, setOnboardComplete] = useState(false);
  const [onboardPaypalComplete, setOnboardPaypalComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState<any[]>([]);
  const [duration, setDuration] = useState('yearToDate');
  const [fundraiser, setFundraiser] = useState('all');
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [fetchingData, setFetchingData] = useState(false);

  // detect viewer timezone
  const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

  useEffect(() => {
    if (reduxOrg._id) {
      setLoading(true);
      try {
        API.getStripeAcct(reduxOrg.actionItems?.stripeID)
          .then((res: any) => {
            if (res.data?.details_submitted) {
              setOnboardComplete(true);
              API.findNP(reduxOrg._id)
                .then((nonprofit: any) => {
                  if (!nonprofit.stripeComplete) {
                    API.updateNP({ ...nonprofit.data, stripeComplete: true })
                      .catch((err: any) => {
                        console.log(err)
                      });
                  }
                }).catch((err: any) => {
                  console.log(err)
                });;
            }
            setLoading(false);
          })
        if (reduxOrg?.paypal?.merchantId) {
          setOnboardPaypalComplete(true);
        }
      } catch (error) {
        console.log(error);

      } finally {
        console.log('finally calling');
        setLoading(false)
      }
    }
  }, []);

  useEffect(() => {
    if (reduxOrg._id) {
      API.getNpCampaigns(reduxOrg._id).then((result) => {
        setCampaigns(result.data.sort((a: any, b: any) => b.createdAt - a.createdAt));
      });
    }
  }, [reduxOrg._id]);

  useEffect(() => {
    if (reduxOrg._id && (onboardComplete || onboardPaypalComplete)) {
      setFetchingData(true);
      if (duration === 'custom') {
        if (customStartDate && customEndDate) {
          let query = `duration=${duration}&fundraiser=${fundraiser}&startDate=${customStartDate}&endDate=${customEndDate}`;
          // include viewer tz so server can compute day boundaries in user's timezone if desired
          const tzQuery = `${query}&tz=${encodeURIComponent(userTz)}`;
          API.getAllDonationsForNp(reduxOrg._id, tzQuery)
            .then((response) => {
              setPayments(response.data);
            })
            .catch((err: any) => console.log(err))
            .finally(() => setFetchingData(false));
        } else {
          setFetchingData(false);
          setPayments([]);
        }
      } else {
        let query = `duration=${duration}&fundraiser=${fundraiser}`;
        // include viewer tz so server can compute day boundaries in user's timezone if desired
        const tzQuery = `${query}&tz=${encodeURIComponent(userTz)}`;
        API.getAllDonationsForNp(reduxOrg._id, tzQuery)
          .then((response) => {
            setPayments(response.data);
          })
          .catch((err: any) => console.log(err))
          .finally(() => setFetchingData(false));
      }
    }
  }, [reduxOrg._id, duration, fundraiser, onboardComplete, onboardPaypalComplete, customStartDate, customEndDate, userTz]);

  // const handleShowReport = () => {
  //   // Implement if needed
  // };

  const handleDownloadReport = () => {
    // Implement if needed
  };

  const renderOnboardingComplete = () => {
    return (
      <>
        {fetchingData && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            borderRadius: '12px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '10px'
            }}>
              <div className="spinner-border text-primary" role="status">
              
              </div>
              {/* <span style={{ color: '#6c757d', fontSize: '14px' }}>Loading payments...</span> */}
            </div>
          </div>
        )}
        <DonationsTable
        isDashboardPage={false}
          donations={payments}
          // onShowReport={handleShowReport}
          onDownloadReport={handleDownloadReport}
          duration={duration}
          setDuration={setDuration}
          fundraiser={fundraiser}
          setFundraiser={setFundraiser}
          campaigns={campaigns}
          npID={reduxOrg._id}
          title="Donations"
          enableCustomDate={true}
          customStartDate={customStartDate}
          setCustomStartDate={setCustomStartDate}
          customEndDate={customEndDate}
          setCustomEndDate={setCustomEndDate}
        />
      </>
    );
  };

  const renderManagePay = () => {
    if (loading) {
      return <h3>LOADING</h3>;
    } else if (onboardComplete || onboardPaypalComplete) {
      return renderOnboardingComplete();
    }
  };

  return (
    <div className='manage-pay-wrapper bbb'>
      {loading ? null :
        <>
          {!onboardComplete && !onboardPaypalComplete &&
            <div style={{ height: '300px' }} className='no-data-to-show'>
              Connect Stripe or PayPal account in Connect Payments to start receiving donations.
              <Link to={'/connect-payments'}>Connect Payments</Link>
            </div>
          }
        </>
      }
      {renderManagePay()}
    </div>
  );
};

export default ManagePay;